import styled from "styled-components";
import { Input, List, Modal, Typography } from "antd";

export const StyledAddModal = styled(Modal)`
  width: 300px !important;

  .ant-modal-content {
    padding: 0;
    background-color: ${({ theme }) => theme.palette.background.default};

    .ant-modal-close {
      display: none;
    }
    .ant-modal-footer {
      display: none;
    }
  }
`;

export const StyledAddModalInput = styled(Input)`
  width: 100%;
  height: 40px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  color: ${({ theme }) => theme.palette.text.primary} !important;
  background-color: ${({ theme }) =>
    theme.palette.background.secondary} !important;

  &::placeholder {
    color: ${({ theme }) => theme.palette.text.secondary} !important;
    background-color: ${({ theme }) =>
      theme.palette.background.secondary} !important;
  }
`;

export const StyledAddModalListContainer = styled.div`
  height: 100px;
  border-radius: 15px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};

  .simplebar-offset {
    border-radius: 15px;
    overflow: hidden;
  }
`;

export const StyledAddModalList = styled(List)`
  width: 100%;
  border-radius: 15px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};

  .ant-list-item {
    padding: 10px;
    background-color: ${({ theme }) =>
      theme.palette.background.paper} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;
    border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
    cursor: pointer;

    .ant-list-item-meta {
      .ant-list-item-meta-title {
        font-size: 14px;
        line-height: 1;
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }
      .ant-list-item-meta-description {
        font-size: 12px;
        line-height: 1;
        color: ${({ theme }) => theme.palette.text.secondary} !important;
      }
    }
  }
`;

export const StyledModalContainer = styled.div`
  padding: 10px;
  color: ${({ theme }) => theme.palette.text.primary} !important;
`;

export const StyledModalTitle = styled(Typography.Text)`
  font-size: 12px;
  line-height: 1;
`;
